import { render } from "./GridTipuriActivitati.vue?vue&type=template&id=6c80e5a1&scoped=true&ts=true"
import script from "./GridTipuriActivitati.vue?vue&type=script&lang=ts"
export * from "./GridTipuriActivitati.vue?vue&type=script&lang=ts"

import "./GridTipuriActivitati.vue?vue&type=style&index=0&id=6c80e5a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c80e5a1"]])

export default __exports__